export const plugins = {
    dataCarrier: {
        availableStatementPeriodicities: ['DAILY', 'WEEKLY', 'MONTHLY'],
        displayBulkDownloadFormatSelect: false,
        availableStatementFormats: ['ABO_STANDARD', 'ABO_INTERNAL', 'CSV_COMMA', 'CSV_SEMICOLON'],
    },
};
